import type { IconSvgObject } from './types';

const Touch08Icon: IconSvgObject = [
  ["path", { d: "M14 12.3546V10.5C14 9.67157 13.3284 9 12.5 9H11M17 13V11.5C17 10.6716 16.3284 10 15.5 10H14.2328M11 9V11.4211M11 9V4C11 3.17157 10.3284 2.5 9.5 2.5C8.67157 2.5 8 3.17157 8 4V9M17.3237 11H18.5C19.3284 11 20 11.6716 20 12.5V18.5C20 20.1569 18.6569 21.5 17 21.5H9.60555C8.60249 21.5 7.6658 20.9987 7.1094 20.1641L4.50385 16.2558C4.17531 15.763 4 15.1839 4 14.5917V14.2426C4 13.447 4.31607 12.6839 4.87868 12.1213L8 9M8 14V9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Touch08Icon;
